import { render, staticRenderFns } from "./InDmHeader.vue?vue&type=template&id=012d2b1b&scoped=true"
import script from "./InDmHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmHeader.vue?vue&type=style&index=0&id=012d2b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d2b1b",
  null
  
)

export default component.exports